export default __webpack_public_path__ + "static/12.04-31b81bee45a725e87890a71774974fde.png";